import { useState, useEffect } from 'react';

export function useScrollDirection() {
    const [scrollDirection, setScrollDirection] = useState<'up' | 'down' | null>(null);
    const [prevOffset, setPrevOffset] = useState(0);
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            const currentOffset = window.scrollY;
            const direction = currentOffset > prevOffset ? 'down' : 'up';

            if (direction !== scrollDirection && (currentOffset - prevOffset > 10 || currentOffset - prevOffset < -10)) {
                setScrollDirection(direction);
            }

            // Auto-hide logic: Hide on down, Show on up
            // Always show if near top (< 50px)
            if (currentOffset < 50) {
                setVisible(true);
            } else if (direction === 'down' && currentOffset > 50) {
                setVisible(false);
            } else if (direction === 'up') {
                setVisible(true);
            }

            setPrevOffset(currentOffset);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [scrollDirection, prevOffset]);

    return { scrollDirection, visible };
}
